import gettext from '@sdk/lang/gettext';
import { GroupedPersonaPicker } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/GroupedPersonaPicker';
import FieldLabel from '@sdk/components/forms/components/FieldLabel';
import { PersonaPickerOption } from '@sdk/components/forms/personaPickers/PersonaPicker/personaPicker.types';

import { FieldWrapper } from '@web/conversations/ComposeConversation/composeConversation.styles';
import { MembersField } from '@web/conversations/types/ConversationFields';

import { useConversationMembersField } from './conversationMembersField.hooks';

type Props = {
  members: MembersField;
  hasError?: boolean;
  extraPickerOptions?: PersonaPickerOption[];
};

export const ConversationMembersField = ({ members, hasError, extraPickerOptions }: Props) => {
  const { groupHeadersDefinition, nonDeletableIds, options } =
    useConversationMembersField(extraPickerOptions);

  return (
    <FieldWrapper>
      <FieldLabel label={gettext('members')} htmlFor="conversation-members" invalid={hasError}>
        <GroupedPersonaPicker
          id="conversation-members"
          hasError={hasError}
          options={options}
          selectedItems={members.value}
          nonDeletableIds={nonDeletableIds}
          onSelectedItemsChange={members.onChange}
          placeholder={gettext('Add users, positions, locations or groups')}
          groupHeadersDefinition={groupHeadersDefinition}
        />
      </FieldLabel>
    </FieldWrapper>
  );
};
